import { NgModule } from '@angular/core';

import { FormlyAutocompleteModule } from './components/autocomplete/autocomplete.module';
import { FormlyButtonModule } from './components/button/button.module';
import { FormlyCheckboxModule } from './components/checkbox/checkbox.module';
import { FormlyDateModule } from './components/date/date.module';
import { FormlyFormFieldModule } from './components/form-field/form-field.module';
import { FormlyGridSelectModule } from './components/grid-select/grid-select.module';
import { FormlyInputModule } from './components/input/input.module';
import { FormlyMultiColumnComboBoxModule } from './components/multicolumncombobox/multicolumncombobox.module';
import { FormlyMultiSelectModule } from './components/multiselect/multiselect.module';
import { FormlyMultiSelectAllModule } from './components/multiSelectAll/multiSelectAll.module';
import { FormlyMultiSelectTreeModule } from './components/multiselecttree/multiselecttree.module';
import { FormlyNumericModule } from './components/numeric/numeric.module';
import { FormlyProgressBarModule } from './components/progressBar/progressBar.module';
import { FormlyRadioModule } from './components/radio/radio.module';
import { FormlySelectModule } from './components/select/select.module';
import { FormlyTextModule } from './components/text/text.module';
import { FormlyTextButtonModule } from './components/text-button/text-button.module';
import { FormlyTextAreaModule } from './components/textarea/textarea.module';
import { FormlyTextareaButtonModule } from './components/textarea-button/textarea-button.module';
import { FormlyTimeModule } from './components/time/time.module';
import { FormlySwitchModule } from './components/switch/switch.module';
import { FormlyEditorModule } from './components/editor/editor.module';
import { FormlyLocaleTabsModule } from './components/locale-tabs/locale-tabs.module';
import { FormlyHtmlEditorModule } from './components/htmleditor/htmleditor.module';
import { FormlyDatepickerModule } from './components/datepicker/datepicker.module';
import { FormlySimpleFormFieldModule } from './components/form-field-simple/form-field.module';
import { FormlyTabsModule } from './components/tabs/tabs.module';

@NgModule({
    imports: [
        FormlyAutocompleteModule,
        FormlySimpleFormFieldModule,
        FormlyFormFieldModule,
        FormlyInputModule,
        FormlyTextAreaModule,
        FormlyTextareaButtonModule,
        FormlyRadioModule,
        FormlyCheckboxModule,
        FormlySelectModule,
        FormlyDateModule,
        FormlyDatepickerModule,
        FormlyTimeModule,
        FormlyButtonModule,
        FormlyMultiColumnComboBoxModule,
        FormlyMultiSelectModule,
        FormlyMultiSelectAllModule,
        FormlyMultiSelectTreeModule,
        FormlyNumericModule,
        FormlyProgressBarModule,
        FormlyTextModule,
        FormlyTextButtonModule,
        FormlyGridSelectModule,
        FormlySwitchModule,
        FormlyTabsModule,
        FormlyEditorModule,
        FormlyLocaleTabsModule,
        FormlyHtmlEditorModule
    ],
})
export class FormlyKendoModule { }
